const routes = [
  {
    path: "/videoBackOld", // 主页面
    name: "videoBack",
    redirect: "/videoBack/index",
    component: () => import("./view/Home"),
    meta: {
      requireAuth: false,
      routerAlive: true
    },
    children: [
      {
        path: "index", // 实时浏览
        name: "videoBackIndex",
        component: () => import("./view/index"),
        meta: {
          module:"videoBack",
          requireAuth: false,
          routerAlive: true
        }
      },

    ]
  }
];

export default routes;
